// Boutique profile helpers — "caisse" (universal POS) vs "mode" (fashion)
// Single source of truth for every profile-dependent UI decision.

export const CAISSE_TYPES = ["restaurant", "bar", "epicerie", "boissons", "general"];

const readBoutique = () => {
  try {
    return JSON.parse(localStorage.getItem("boutique") || "{}");
  } catch {
    return {};
  }
};

export const getBoutiqueType = () => {
  const b = readBoutique();
  return b.type || b.boutique_type || "";
};

export const getBoutiqueProfile = () => {
  const b = readBoutique();
  if (b.profile) return b.profile;
  return CAISSE_TYPES.includes(getBoutiqueType()) ? "caisse" : "mode";
};

export const isCaisseProfile = () => getBoutiqueProfile() === "caisse";

export const isBoissonsBoutique = () => getBoutiqueType() === "boissons";

// Feature flags derived from profile
export const getFeatures = () => {
  const caisse = isCaisseProfile();
  const boissons = isBoissonsBoutique();
  return {
    profile: caisse ? "caisse" : "mode",
    variants: !caisse || boissons,
    gender: !caisse,
    labels: !caisse,
    vitrine: !caisse,
    customers: !caisse,
    orders: !caisse,
    chat: !caisse,
    tableOrders: caisse,
    categoryLabel: caisse ? "Catégorie" : "Collection",
    categoryLabelPlural: caisse ? "Catégories" : "Collections",
    productsSubtitle: boissons
      ? "Gérez vos boissons et produits"
      : caisse ? "Gérez vos articles et votre stock" : "Gérez votre collection de vêtements",
  };
};

export const CONTENANCE_OPTIONS = [
  "25cl", "33cl", "50cl", "65cl", "75cl", "1L", "1.5L", "2L", "3L", "5L", "Unique"
];

export const FORMAT_OPTIONS = [
  { name: "Bouteille", hex: "#166534" },
  { name: "Canette", hex: "#6B7280" },
  { name: "Pack x6", hex: "#B45309" },
  { name: "Pack x12", hex: "#92400E" },
  { name: "Casier", hex: "#7C2D12" },
  { name: "Fût", hex: "#78350F" },
  { name: "Sachet", hex: "#DB2777" },
  { name: "Boîte", hex: "#4F46E5" },
];

export const getVariantLabels = () => {
  if (isBoissonsBoutique()) {
    return { size: "Contenance", color: "Format", variantsTitle: "Variantes (Contenance / Format)" };
  }
  return { size: "Taille", color: "Couleur", variantsTitle: "Variantes (Taille / Couleur)" };
};

// True when a product is a "simple" article (single auto-generated Standard variant)
export const isSimpleProduct = (product) =>
  (product?.variants?.length || 0) <= 1 &&
  (product?.variants?.[0]?.size === "Unique" && product?.variants?.[0]?.color === "Standard");
